var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllprojects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46298 2.24992H13.5371V9.33325H3.46298V2.24992ZM13.5371 10.7499C13.871 10.7499 14.1913 10.6007 14.4275 10.335C14.6636 10.0693 14.7963 9.70897 14.7963 9.33325V2.24992C14.7963 1.46367 14.2296 0.833252 13.5371 0.833252H3.46298C2.76409 0.833252 2.20372 1.46367 2.20372 2.24992V9.33325C2.20372 9.70897 2.33639 10.0693 2.57255 10.335C2.8087 10.6007 3.129 10.7499 3.46298 10.7499H0.944458V12.1666H16.0556V10.7499H13.5371Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllprojects);
export default __webpack_public_path__ + "static/media/allprojects.6d954a37.svg";
export { ForwardRef as ReactComponent };